import * as React from "react";
import Svg, { G, Path, Defs, ClipPath } from "react-native-svg";

export function CrossBlack(props: any) {
  return (
    <Svg
      width={33}
      height={32}
      viewBox="0 0 33 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <G
        clipPath="url(#clip0_1095_23188)"
        stroke="#251F2C"
        strokeWidth={2}
        strokeMiterlimit={10}
        strokeLinecap="round"
      >
        <Path d="M1.876 30.545l29.25-29.09M31.126 30.545L1.876 1.455" />
      </G>
      <Defs>
        <ClipPath id="clip0_1095_23188">
          <Path fill="#fff" transform="translate(.5)" d="M0 0H32V32H0z" />
        </ClipPath>
      </Defs>
    </Svg>
  );
}
